/**
 *
 * Asynchronously loads the component for Videos
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Videos = lazyLoad(() => import('./index'));
